import Vue from 'vue'
import shortkey from 'vue-shortkey'

Vue.use(shortkey)
